/* ms-brand.js — Mr. Sksrblou. Chargé en différé, sans dépendance.
   1. boutons « Commander » hors du formulaire : ouvrent Releasit, sinon remontent au bouton de commande
   2. relais des événements du formulaire Releasit, point de branchement d'un futur pixel */
(function () {
  'use strict';

  // ---- 1. Boutons « Commander » ------------------------------------------------
  // Releasit place son bouton dans le formulaire produit de Dawn. On clique dessus,
  // ou on ouvre sa fenêtre par son API. S'il n'est pas chargé, on remonte au formulaire.
  var RSI_BUTTONS = [
    '#rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '[id^="rsi"] button'
  ];
  function releasitButton() {
    for (var i = 0; i < RSI_BUTTONS.length; i++) {
      var el = document.querySelector(RSI_BUTTONS[i]);
      if (el && !el.closest('[data-ms-order]')) return el;
    }
    return null;
  }
  function order() {
    var btn = releasitButton();
    if (btn) { btn.click(); return; }
    try {
      var v2 = window._rsiV2;
      if (v2 && typeof v2.setState === 'function') { v2.setState({ isOpen: true }); return; }
    } catch (e) {}
    var form = document.querySelector('product-form, .product-form, product-info');
    if (form) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ms-order]') : null;
    if (!t) return;
    e.preventDefault();
    order();
  });

  // ---- 2. Relais d'événements -----------------------------------------------------
  // Aucun pixel au lancement. Point de branchement :
  //   document.addEventListener('ms:formulaire_ouvert', ...)
  //   document.addEventListener('ms:commande_passee', function (e) { e.detail.order })
  var sent = {};
  function emit(name, detail, key) {
    if (sent[key]) return;
    sent[key] = true;
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }
  document.addEventListener('rsi::v2::update', function (e) {
    var d = (e && e.detail) || {};
    if (d.orderResponse) emit('ms:commande_passee', { order: d.orderResponse }, 'order');
    else if (d.isOpen) emit('ms:formulaire_ouvert', {}, 'open');
  });

  // Listes à glisser de Dawn (colonnes « Comment l'utiliser » sur téléphone) sans lien ni bouton :
  // atteignables au clavier pour pouvoir les faire défiler avec les flèches.
  function sliders() {
    document.querySelectorAll('ul.slider').forEach(function (s) {
      if (s.hasAttribute('tabindex') || s.querySelector('a, button, input, select, textarea, [tabindex]')) return;
      s.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sliders); else sliders();
})();
